module.exports = __webpack_public_path__ + "static/media/opacity.4a7c4b67.svg";